(()=>{
'use strict';
let state=null;
function initialize(){
 const region=document.querySelector('[data-bb-collection]');
 document.querySelectorAll('[data-bb-form-status]').forEach(e=>{const details=e.closest('details');if(details)details.open=true});
 if(!region){state=null;return}
 const grid=region.querySelector('[data-bb-products]');
 const cards=[...region.querySelectorAll('[data-bb-card]')];
 const controls=region.querySelector('[data-bb-filters]');
 const sort=region.querySelector('[data-bb-sort]');
 const categories=['All',...new Set(cards.map(c=>c.dataset.audience)),...new Set(cards.map(c=>c.dataset.category))];
 controls.replaceChildren(...categories.map(value=>{const b=document.createElement('button');b.type='button';b.dataset.bbFilter=value;b.textContent=value==='All'?'All pieces':value;b.setAttribute('aria-pressed','false');return b}));
 let filter=new URLSearchParams(location.search).get('category')||'All';
 if(!categories.includes(filter))filter='All';
 function render(){
  const ordered=[...cards];
  if(sort.value==='low')ordered.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
  else if(sort.value==='high')ordered.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
  else if(sort.value==='name')ordered.sort((a,b)=>a.dataset.name.localeCompare(b.dataset.name));
  else ordered.sort((a,b)=>Number(a.dataset.index)-Number(b.dataset.index));
  let visible=0;
  for(const card of ordered){card.hidden=filter!=='All'&&card.dataset.category!==filter&&card.dataset.audience!==filter;if(!card.hidden)visible++;grid.append(card)}
  region.querySelector('[data-bb-empty]').hidden=visible>0;
  controls.querySelectorAll('button').forEach(b=>{const selected=b.dataset.bbFilter===filter;b.classList.toggle('selected',selected);b.setAttribute('aria-pressed',String(selected))});
 }
 state={region,select(value){filter=categories.includes(value)?value:'All';render()}};
 sort.addEventListener('change',render);
 render();
}
document.addEventListener('click',event=>{
 const menu=document.querySelector('#mobile-menu');
 if(event.target.closest('.bb-store a')&&menu)menu.open=false;
 const trigger=event.target.closest('[data-bb-filter]');
 if(!trigger||!state)return;
 event.preventDefault();state.select(trigger.dataset.bbFilter);
 state.region.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
 if(menu)menu.open=false;
});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
document.addEventListener('shopify:section:load',initialize);
})();
